import { BrowserRouter } from "react-router-dom";
import Layout from "./layout/Layout";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Layout />
      </LocalizationProvider>
    </BrowserRouter>
  );
}

export default App;
